import { Injectable, inject } from "@angular/core";
import { CrudService, HttpResponsesHandlersFactory, IHttpResponseHandlerSettings } from "@bbwt/modules/data-service";
import { HttpClient, HttpEvent, HttpRequest } from "@angular/common/http";
import { FormModuleDTO, FormModuleMinDTO } from "@main/formio/dto/formModuleDTO";
import { Observable } from "rxjs";
import { UserService } from "@main/users/user.service";

@Injectable()
export class FormIOModuleService extends CrudService<FormModuleDTO> {
    private readonly userService = inject(UserService);

    public readonly url = "api/formio-module";
    public readonly entityTitle = "Form Module";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    uploadIcon(formData: FormData): Observable<HttpEvent<any>> {
        return this.http.request(new HttpRequest("POST", `${this.url}/upload-icon`, formData, { reportProgress: true }));
    }

    getExistingModuleForms(responseHandlerSettings?: IHttpResponseHandlerSettings): Promise<FormModuleDTO[]> {
        return this.handleRequest<FormModuleDTO[]>(
            this.http.get<FormModuleDTO[]>(`${this.url}/existing-module-forms`),
            this.handlersFactory.getForReadAll(responseHandlerSettings))
    }

    async getAllMin(): Promise<FormModuleMinDTO[]> {
        if (!this.userService.isLogged) {
            return [];
        }

        return await this.handleRequest<FormModuleMinDTO[]>(
            this.http.get<FormModuleMinDTO[]>(`${this.url}/all-min`),
            this.handlersFactory.getForReadAll()
        );
    }
}
